import { Badge, Box, Link, styled } from "@mui/material";
import ProjectsTabsHeader from "./projects-tabs-header";
import { SC_Constants } from "utils/sc-constants";
import { useNavigate } from "react-router";
import ProjectsOverview from "./projects-overview"
import { Ico_FolderHeader, Ico_Close } from "@sagecentral/core-ui"
import Grid from '@mui/material/Unstable_Grid2';
import { IProjectHeaderInfo } from "models/projects";
import ProjectHeaderLink from "./ProjectHeaderLink";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

type ProjectsHeaderProps = {
    project: IProjectHeaderInfo
};

const ProjectsHeader = (props: ProjectsHeaderProps) => {
    const { project } = props;
    const currentURL: string = window.location.href;
    const suffix: string = currentURL.includes('all') ? 'all' : 'my';
    const returnUrl = `/projects/`+suffix;

    const navigate = useNavigate();
    const HandleCloseProjectOverview = () => {
        const previousPath = sessionStorage.getItem('previousURL');
        const projectProgress = localStorage.getItem(SC_Constants.projectProgress);
        if ( previousPath && !previousPath.includes("signin") && !previousPath.includes("login")) {
            navigate(-1);
        }
        else if (projectProgress !== undefined && projectProgress !== null && projectProgress.length > 0) {
            if (projectProgress === suffix) {
                navigate(returnUrl);
            }
            else {
                navigate(`${returnUrl}/${projectProgress}`);
            }
        }
        else {
            navigate(`${returnUrl}/in-progress`);
        }
    }


    
    return (
        <Box sx={{ witdh: '100%' }}>
            <Grid container spacing={0} >
                <ProjectHeaderLink project={props.project} />
                <Grid xs={1} mdOffset="auto">
                    <Box sx={{float:'right',cursor:'pointer'}} onClick={HandleCloseProjectOverview}>
                        <svg fill="none" height={24} width={24}><Ico_Close/></svg>
                    </Box>
                </Grid>
            </Grid>
            <ProjectsTabsHeader 
            ProjectId = { project.id }
            />
        </Box>
    );
}

export default ProjectsHeader